// Tags
const TAG_HIGH = "High Priority";
//const TAG_ONHOLD = "On Hold";
const TAG_REWORK = "Rework";
const TAG_BATCH = "Batch Oven";
const JOBT_STOCKSTRIP = "Nuwall Stock to Strip";
const JOBT_SCHEDULEDTIME = "Scheduled Time";

const SCHEDULEDTIME_MAINTENANCE = "Maintenance";
const SCHEDULEDTIME_MEETING = "Meeting";
const SCHEDULEDTIME_ADMIN = "Admin";
const SCHEDULEDTIME_OTHER = "Other";
// Status
const JOBSTAT_DRAFT = 0;
const JOBSTAT_SCHEDULE = 1;
const JOBSTAT_ONHOLD = 2;
const JOBSTAT_UPCOMING = 3;
const JOBSTAT_BLASTING = 4;
const JOBSTAT_STRIPPING = 5;
const JOBSTAT_LINE1 = 6;
const JOBSTAT_LINE2 = 7;
const JOBSTAT_PACKING = 8;
const JOBSTAT_INVOICE = 10;
const JOBSTAT_COMP = 11;

const PACK_CASE = 1;

const PREPRO_PRETREAT = 0;
const PREPRO_BLASTING = 1;
const PREPRO_STRIPPING = 2;

const JOBWAR_REQUIRED = 0;
const JOBWAR_APPSUB = 1;
const JOBWAR_SAMPSENT = 2;
const JOBWAR_COMPLETED = 3;

const VALERR_MISSING_PRICE = 1;
const VALERR_LM_QUANTITY_MISMATCH = 2;
const VALERR_SQM_QUANTITY_MISMATCH = 3;
const VALERR_PREMIUM_POWDER_MISMATCH = 4;

export default {
    PREPRO_PRETREAT,
    PREPRO_BLASTING,
    PREPRO_STRIPPING,
    TAG_HIGH,
    //TAG_ONHOLD,
    TAG_REWORK,
    TAG_BATCH,
    JOBT_STOCKSTRIP,
    JOBT_SCHEDULEDTIME,
    PACK_CASE,
    scheduledTimeReasons: [
        SCHEDULEDTIME_MAINTENANCE,
        SCHEDULEDTIME_MEETING,
        SCHEDULEDTIME_ADMIN,
        SCHEDULEDTIME_OTHER
    ],
    reworkReasons: [
        {
            reason: "Contamination on Profile",
            icon: "mdi-water-alert-outline",
            subReasons: ["Ash", "Dust/Dirty", "Finger Marks", "Water Marks", "Oil Marks"]
        },
        {
            reason: "Damaged Product",
            icon: "mdi-archive-alert-outline",
            subReasons: ["Scratch", "Damaged/Fell in Oven", "Fell in Oven - no damage"]
        },
        {
            reason: "P88 Error",
            icon: "mdi-hanger",
            subReasons: ["Jig Marks/incorrect hanging", "Missing Profiles", "Incorrect Item"]
        },
        {
            reason: "Powder Coating Application",
            icon: "mdi-spray",
            subReasons: ["Heavy Coating/Orange Peel", "Uneven Coating", "Light Coating", "Blemishes/Lumps", "Pitting", "Sprayed the wrong Surface", "Colour discolouration"]
        },
        {
            reason: "Profile not Cured",
            icon: "mdi-toaster-oven",
            subReasons: ["Under Cured"]
        },
        {
            reason: "Wrong Colour/Powder Range",
            icon: "mdi-palette-outline",
            subReasons: ["Incorrect Powder/Colour"]
        },
        {
            reason: "Other",
            icon: "mdi-file-question-outline",
            subReasons: []
        }
    ],
    packaging: [
        { title: 'Standard', value: null },
        { title: 'Case', value: 1 }
    ],
    tags: [
        {
            name: TAG_HIGH,
            icon: "mdi-flag",
            colour: "orange-darken-1",
        },
        {
            name: TAG_REWORK,
            icon: "mdi-recycle",
            colour: "red-darken-1",
        },
        {
            name: TAG_BATCH,
            icon: "mdi-toaster-oven",
            colour: "orange-darken-1",
        },
        {
            name: JOBT_STOCKSTRIP,
            icon: 'mdi-eyedropper-remove',
            colour: 'blue-darken-3',
        }
    ],
    JOBSTAT_DRAFT,
    JOBSTAT_SCHEDULE,
    JOBSTAT_ONHOLD,
    JOBSTAT_UPCOMING,
    JOBSTAT_BLASTING, 
    JOBSTAT_STRIPPING,
    JOBSTAT_LINE1,
    JOBSTAT_LINE2,
    JOBSTAT_PACKING,
    JOBSTAT_INVOICE,
    JOBSTAT_COMP,
    lines: [
        { value: JOBSTAT_LINE1, text: "Line 1" },
        { value: JOBSTAT_LINE2, text: "Line 2" },
    ],
    statuses: [
        {
            id: JOBSTAT_DRAFT,
            icon: 'mdi-progress-pencil',
            title: 'Draft',
            colour: 'grey'
        },
        {
            id: JOBSTAT_SCHEDULE,
            icon: 'mdi-calendar-blank',
            title: 'Schedule',
            colour: 'light-blue'
        },
        {
            id: JOBSTAT_ONHOLD,
            icon: 'mdi-pause-octagon',
            title: 'On Hold',
            colour: 'orange'
        },
        {
            id: JOBSTAT_UPCOMING,
            icon: 'mdi-fast-forward',
            title: 'Upcoming',
            colour: 'blue'
        },
        {
            id: JOBSTAT_BLASTING,
            icon: 'mdi-spray',
            title: 'Blasting',
            colour: 'indigo'
        },
        {
            id: JOBSTAT_STRIPPING,
            icon: 'mdi-bucket-outline',
            title: 'Stripping',
            colour: 'brown'
        },
        {
            id: JOBSTAT_LINE1,
            icon: 'mdi-spray-bottle',
            title: 'Line 1',
            colour: 'blue-darken-3'
        },
        {
            id: JOBSTAT_LINE2,
            icon: 'mdi-spray-bottle',
            title: 'Line 2',
            colour: 'blue-darken-3'
        },
        {
            id: JOBSTAT_PACKING,
            icon: 'mdi-package-variant',
            title: 'Packing',
            colour: 'teal-lighten-2'
        },
        {
            id: 'SPARE',
            icon: '',
            title: '',
            color: ''
        },
        {
            id: JOBSTAT_INVOICE,
            icon: 'mdi-invoice-text-outline',
            title: 'Invoice',
            colour: 'blue-accent-1',
        },
        {
            id: JOBSTAT_COMP,
            icon: 'mdi-check-circle',
            title: 'Completed',
            colour: 'green-lighten-2'
        },
    ],
    JOBWAR_REQUIRED,
    JOBWAR_APPSUB,
    JOBWAR_SAMPSENT,
    JOBWAR_COMPLETED,
    VALERR_MISSING_PRICE,
    VALERR_LM_QUANTITY_MISMATCH,
    VALERR_SQM_QUANTITY_MISMATCH,
    VALERR_PREMIUM_POWDER_MISMATCH,
    validationErrors: [
        {
            id: VALERR_MISSING_PRICE,
            title: 'Missing Price',
            description: 'Line item has no unit price set'
        },
        {
            id: VALERR_LM_QUANTITY_MISMATCH,
            title: 'L/M Quantity Mismatch',
            description: 'Stored quantity does not match total metres calculated from the description'
        },
        {
            id: VALERR_SQM_QUANTITY_MISMATCH,
            title: 'SQM Quantity Mismatch',
            description: 'Stored quantity does not match total square metres calculated from the description'
        },
        {
            id: VALERR_PREMIUM_POWDER_MISMATCH,
            title: 'Premium Powder Surcharge Mismatch',
            description: 'Premium powder surcharge does not match the order total (outside 5% tolerance)'
        },
    ],
    warrantyStatuses: [
        {
            id: JOBWAR_REQUIRED,
            icon: 'mdi-file-alert-outline',
            title: 'Warranty Required',
            colour: 'orange'
        },
        {
            id: JOBWAR_APPSUB,
            icon: 'mdi-check-network-outline',
            title: 'Application Submitted',
            colour: 'blue'
        },
        {
            id: JOBWAR_SAMPSENT,
            icon: 'mdi-briefcase-check',
            title: 'Samples Sent',
            colour: 'light-green'
        },
        {
            id: JOBWAR_COMPLETED,
            icon: 'mdi-check-circle-outline',
            title: 'Completed',
            colour: 'green'
        },
    ],
}